<template>
  <div v-if="visible">
    <div class="gcloading">
      <img src="/webAssets/images/img/animation_load.gif">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.isShow
    }
  },
  watch: {
    isShow(val) {
      this.visible = val
    }
  }
}
</script>
<style lang="scss" scoped>
  .gcloading{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 999;
  }
</style>
